<div class="editRoles__container">
  <div class="editRoles__header">
    <div class="editRoles__title">
      @switch (mode) {
      @case ('create') {
      Create Workflow
      }
      @case ('update') {
      Edit {{ workflowData?.name }}
      }
      @case ('view') {
      {{ workflowData?.name }}
      }
      @default {
      Workflow
      }
      }
    </div>
    <div class="editRoles__crossIcon" (click)="handleClosePopup({isClose : true})">
      <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
    </div>
  </div>
  <div class="workflowForm__contentWrapper">
    <form [formGroup]="workflowForm">

      <div class="d-flex row align-items-baseline">
        <div class="col-md-4">
          @if (mode !== 'view') {
          <app-input-filed placeholder="Enter Name" label="Name" [control]="$any(workflowForm).controls['name']"
            [value]="$any(workflowForm).controls['name'].value" name="name" [starIcon]="'*'"></app-input-filed>
          @if (workflowForm.controls?.['name']?.invalid &&
          (workflowForm.controls?.['name']?.dirty ||
          workflowForm.controls?.['name']?.touched)) {
          <div class="alert_required">
            @if (workflowForm.controls?.['name']?.errors?.['required']) {
            <div>
              <small class="text-danger">Name is
                required.</small>
            </div>
            }
          </div>
          }
          }
          @if (mode === 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Name
            </div>
            <div class="input-fieldValue">{{ workflowData?.name }}</div>
          </div>
          }

        </div>
        <div class="col-md-4">
          @if (mode !== 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Document Category<span style="color: chocolate;">*</span>
            </div>
            <select class="select_dropdownOptions" formControlName="documentType">
              <option [value]="''" selected disabled>Select Document Category
              </option>
              @for (item of documentCategoryData; track item) {
              <option [ngValue]="item?._id">
                {{ item?.name }}
              </option>
              }
            </select>
            @if (workflowForm.controls?.['documentType']?.invalid &&
            (workflowForm.controls?.['documentType']?.dirty ||
            workflowForm.controls?.['documentType']?.touched)) {
            <div class="alert_required">
              @if (workflowForm.controls?.['documentType']?.errors?.['required']) {
              <div>
                <small class="text-danger">Document Category is
                  required.</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (mode === 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Document Category
            </div>
            <div class="input-fieldValue">{{ workflowData?.documentType?.name }}</div>
          </div>
          }
        </div>
        <div class="col-md-4">
          @if (mode !== 'view') {
          <app-input-filed placeholder="Enter description" label="Description"
            [control]="$any(workflowForm).controls['description']"
            [value]="$any(workflowForm).controls['description'].value" name="description"
            [starIcon]="'*'"></app-input-filed>
          @if (workflowForm.controls?.['description']?.invalid &&
          (workflowForm.controls?.['description']?.dirty ||
          workflowForm.controls?.['description']?.touched)) {
          <div class="alert_required">
            @if (workflowForm.controls?.['description']?.errors?.['required']) {
            <div>
              <small class="text-danger">Description is
                required.</small>
            </div>
            }
          </div>
          }
          }
          @if (mode === 'view') {
          <div class="select_dropdown">
            <div class="select_dropdownLabel">
              Description
            </div>
            <div class="input-fieldValue">{{ workflowData?.description }}</div>
          </div>
          }

        </div>
      </div>

      <div>
        <div class="stage-header">
          <h2 class="stage-title">Authorization Stages
            <span class="file-icon" placement="right" data-bs-toggle="tooltip"
              [ngbTooltip]="'Either Department or Users is mandatory to select for each stage.'">
              <app-common-icon [faIcon]="faInfoCircle"></app-common-icon>
            </span>
          </h2>
        </div>

        <div formArrayName="stages">
          @for (stage of stages.controls; track $index; let i = $index; let last = $last) {
          <div [formGroupName]="i" class="stage-box">
            <div class="stage-container">
              <div class="d-flex align-items-center justify-content-between">
                @if (mode !== 'view') {
                <div class="stage-subtitle"></div>
                }
                @if (mode !== 'view') {
                <div class="d-flex gap-2">
                  @if (stages.length > 1) {
                  <div class=" text-center">
                    <fa-icon [icon]="faTrash" class="delete_faicon" (click)="removeStage(i)">
                    </fa-icon>
                  </div>
                  }
                  @if (last) {
                  <div class=" text-center">
                    <fa-icon [icon]="faSquarePlus" class="delete_faicon" (click)="addStage()">
                    </fa-icon>
                  </div>
                  }
                </div>
                }
              </div>
              <div class="row d-flex align-items-baseline">
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <app-input-filed placeholder="Enter Name" label="Name"
                    [control]="$any(stageControls(i)).controls['name']" name="name"
                    [value]="$any(stageControls(i)).controls['name'].value" [starIcon]="'*'"></app-input-filed>
                  @if (stageControls(i).controls['name']?.invalid &&
                  (stageControls(i).controls['name']?.dirty ||
                  stageControls(i).controls['name']?.touched)) {
                  <div class="alert_required">
                    @if (stageControls(i).controls['name']?.errors?.['required']) {
                    <div>
                      <small class="text-danger">Name is
                        required.</small>
                    </div>
                    }
                  </div>
                  }
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Name
                    </div>
                    <div class="input-fieldValue">
                      {{workflowData?.stages[i]?.name}}</div>
                  </div>
                  }
                </div>
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Department
                    </div>
                    <select class="select_dropdownOptions" formControlName="department"
                      (change)="onDepartmentChange(i)">
                      <option [value]="''" selected>Select Department
                      </option>
                      @for (item of departmentsData; track item) {
                      <option [ngValue]="item?._id">
                        {{ item?.name }}
                      </option>
                      }
                    </select>
                    @if (stageControls(i).errors?.['atLeastOneSelect'] && stageControls(i).touched) {
                    <div class="alert_required">
                      <small class="text-danger">Please select atleast one Department or Users</small>
                    </div>
                    }
                  </div>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Department
                    </div>
                    <div class="input-fieldValue">
                      {{workflowData?.stages[i]?.departments[0]?.departmentName}}</div>
                  </div>
                  }
                </div>
                <div class="col-md-4">
                  @if (mode !== 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Users
                    </div>
                    <app-auto-search-dropdown style="position: relative;" placeholder="Users" (click)="getUsersList(i)"
                      [isMultiSelect]="true" (selectedValues)="onSelectUser(i, $event)" formControlName="users"
                      [previousSeletedValues]="stageControls(i).controls['users']?.value" (loadMore)="getUsersList(i)"
                      [listData]="usersList" (searchText)="getUsersList(i, $event)">
                    </app-auto-search-dropdown>
                    @if (stageControls(i).errors?.['atLeastOneSelect'] && stageControls(i).touched) {
                    <div class="alert_required">
                      <small class="text-danger">Please select atleast one Department or Users</small>
                    </div>
                    }
                  </div>
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Users
                    </div>
                    <div class="input-fieldValue">
                      {{ workflowData?.stages[i]?.users?.length > 0
                      ? workflowData?.stages[i]?.users[0]?.name + ' (' + workflowData?.stages[i]?.users[0]?.emailAddress
                      + ')'
                      : '-' }}
                      @if (workflowData?.stages[i]?.users?.length > 0) {
                      <span class="dots" data-bs-toggle="dropdown" aria-expanded="false">
                        +more
                      </span>
                      }
                      <ul class="dropdown-menu">
                        @for (user of workflowData?.stages[i]?.users; track user) {
                        <li class="dropdown-item">{{user?.name +'
                          ('+user?.emailAddress+')'}}</li>
                        }
                      </ul>
                    </div>
                  </div>
                  }
                </div>
              </div>
              <div class="row d-flex align-items-baseline pt-3">
                <div class="select_dropdown col-md-4">
                
                  @if (mode !== 'view') {
                  <div class="select_dropdownLabel">
                    Approval Type<span style="color: chocolate;">*</span>
                  </div>
                
                  <select class="select_dropdownOptions" formControlName="approvalType">
                    <option [value]="''" disabled>Select Approval Type</option>
                    @for (item of approvalTypes; track item.value) {
                      <option [ngValue]="item?.value">
                        {{ item?.name }}
                      </option>
                    }
                  </select>
                
                  @if (stageControls(i).controls['approvalType']?.invalid &&
                  (stageControls(i).controls['approvalType']?.dirty ||
                  stageControls(i).controls['approvalType']?.touched)) {
                
                  <div class="alert_required">
                    @if (stageControls(i).controls['approvalType']?.errors?.['required']) {
                    <small class="text-danger">Approval Type is required.</small>
                    }
                  </div>
                  }
                  }
                
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Approval Type
                    </div>
                    <div class="input-fieldValue">
                      {{workflowData?.stages[i]?.approvalType | titlecase}}
                    </div>
                  </div>
                  }
                
                </div>
                <div class="select_dropdown col-md-4" formGroupName="notifications">
                  @if (mode !== 'view') {
                  <div class="select_dropdownLabel">
                    Remainder Type<span style="color: chocolate;">*</span>
                  </div>
                  <select class="select_dropdownOptions" formControlName="reminderType">
                    <option [value]="''" selected disabled>Select Remainder Type
                    </option>
                    @for (item of remainderTypeData; track item) {
                    <option [ngValue]="item?.value">
                      {{ item?.name }}
                    </option>
                    }
                  </select>
                  @if (stageControls(i).get('notifications')?.controls['reminderType']?.invalid &&
                  (stageControls(i).get('notifications')?.controls['reminderType']?.dirty ||
                  stageControls(i).get('notifications')?.controls['reminderType']?.touched)) {
                  <div class="alert_required">
                    @if (stageControls(i).get('notifications')?.controls['reminderType']?.errors?.['required']) {
                    <div>
                      <small class="text-danger">Remainder Type is
                        required.</small>
                    </div>
                    }
                  </div>
                  }
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdownLabel">
                    Remainder Type
                  </div>
                  <div class="input-fieldValue">
                    {{$any(stageControls(i)).get('notifications').controls['reminderType'].value | titlecase}}
                  </div>
                  }
                </div>
                <div class="col-md-4" formGroupName="notifications">
                  @if (mode !== 'view') {
                  <app-input-filed placeholder="Reminder Period" label="Reminder Period"
                    [control]="$any(stageControls(i)).get('notifications').controls['reminderPeriod']"
                    [value]="$any(stageControls(i)).get('notifications').controls['reminderPeriod'].value"
                    name="numberOfDays" [starIcon]="'*'">
                  </app-input-filed>
                  @if (stageControls(i).get('notifications').controls['reminderPeriod']?.invalid &&
                  (stageControls(i).get('notifications').controls['reminderPeriod']?.dirty ||
                  stageControls(i).get('notifications').controls['reminderPeriod']?.touched)) {
                  <div class="alert_required">
                    @if (stageControls(i).get('notifications').controls['reminderPeriod']?.errors?.['required']) {
                    <div>
                      <small class="text-danger">Reminder Period is
                        required.</small>
                    </div>
                    }
                  </div>
                  }
                  }
                  @if (mode === 'view') {
                  <div class="select_dropdown">
                    <div class="select_dropdownLabel">
                      Reminder Period
                    </div>
                    <div class="input-fieldValue">{{
                      $any(stageControls(i)).get('notifications').controls['reminderPeriod'].value
                      }}</div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </form>

  </div>
  <div class="editRoles__footer">
    <div class="d-flex  gap-2">
      <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
        (click)="handleClosePopup({isClose : true})"></app-common-button>
      @if (commonService.orgLock() && mode !== 'view') {
      <app-common-button type="button" [loadingIcon]="verifyLoader" buttonClass="smallFilledButton" [buttonLabel]="mode === 'update' ? 'Update' : 'Save'"
        [disabled]="!workflowForm.valid" (clickEvent)="onSubmit()"></app-common-button>
      }
    </div>
  </div>
</div>

@if (showErorToaster) {
<app-error-toaster [title]="toasterMessage" (closeToaster)="closeToaster()"></app-error-toaster>
}